<template>
    <div class="">
        <div class="row no-gutters py-2 mb-3 ml-3">
			<div class="col-sm-6 pr-3 ">
				<h4 class="atlhr-dashboard-title mt-10">
					<span class="blue-title"></span>Provident Fund Reporting
					<span>
						<a v-bind:href="pageurl">Dashboard</a>
						/ Provident Fund Reporting
					</span>
				</h4>
			</div>
		</div>
        <div class="mt-4 employee-tab row no-gutters py-2 mb-3 ml-3">
            
            <b-tabs pills content-class="" nav-class="justify-content-left pr-2 m-2" nav-wrapper-class="col-md-9 custom-margin custom-tab-nav ml-auto pl-0">
                
                <b-tab lazy title="PF Reports">
                    <b-tabs  tab-class="nav-item-trustee" content-class="mt-4" nav-wrapper-class="trustee-nav-wrapper mt-4">
                        <template v-slot:tabs-start>
                            <b-nav-item disabled href="#" class="trustee-nav-first-wrapper">
                                <div class="trustee-nav-first">
                                    <div class="trustee-nav-head">Provident Fund Reports</div>
                                    <div class="trustee-nav-subhead">Get a clear picture of your Provident Fund. Use this information to better understand your workforce.</div>
                                </div>
                            </b-nav-item>
                        </template> 
                        <b-tab lazy active title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Employee PF Profile</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows total breakdown of any selected Employee’s PF Profile for the Provident Fund scheme.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-employee-profile-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-employee-profile-report>
                            </div>
                     
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Monthly PF Report of Active Employees</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows the aggregate breakdown of any selected period's PF per employee.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-monthly-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-monthly-report>
                            </div>
                     
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Monthly PF Leaver Statement</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows the total Provident Fund breakdown of each Employee who have left the organization or Provident Fund during the selected month.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-monthly-leaver-report :leaver="1" :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-monthly-leaver-report>
                            </div>
                     
                        </b-tab>
                        
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Employee PF Fiscal Year Statement</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows the total Provident Fund breakdown for all Provident Fund registered Employees during selected Fiscal Year.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-fiscal-report  :pf_settings="this.pf_settings" :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-fiscal-report>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-tab>
                <b-tab title="Profit Distribution">
                
                    <b-tabs   tab-class="nav-item-trustee" content-class="mt-4" nav-wrapper-class="trustee-nav-wrapper mt-4">
                        <template v-slot:tabs-start>
                            <b-nav-item disabled href="#" class="trustee-nav-first-wrapper">
                                <div class="trustee-nav-first">
                                    <div class="trustee-nav-head">Provident Fund Profit Distribution Reports</div>
                                    <div class="trustee-nav-subhead">Get a clear picture of how profit earned has been distributed to Employees’ Provident Fund balances. </div>
                                </div>
                            </b-nav-item>
                        </template> 
                        <template>
                            <b-tab lazy active title-item-class="trustee-nav wi-three">
                                <template #title>
                                    <div class="trustee-report-title">
                                        <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                        <div class="text">Profit Distribution Report</div>
                                    </div>
                                    <div class="trustee-report-intro">
                                        This report shows the total profit breakdown of each selected period per employee.
                                    </div>
                                </template>
                                <div class="trustee-tab-wrapper">
                                    <pf-profit-distribute-report-new :pf_settings="this.pf_settings" :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-profit-distribute-report-new>
                                </div>
                            </b-tab>
                        </template>
                    </b-tabs>
                </b-tab>
                <b-tab title="PF Advance Reports">
                    
                    <b-tabs  tab-class="nav-item-trustee" content-class="mt-4" nav-wrapper-class="trustee-nav-wrapper mt-4">
                        <template v-slot:tabs-start>
                            <b-nav-item disabled href="#" class="trustee-nav-first-wrapper">
                                <div class="trustee-nav-first">
                                    <div class="trustee-nav-head">Provident Fund Advance Reports</div>
                                    <div class="trustee-nav-subhead">Get a clear picture of approved and disbursed advances against Employees’ Provident Fund balances. </div>
                                </div>
                            </b-nav-item>
                        </template> 
                        
                        
                        <b-tab lazy active title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">PF Advance Schedule for Individuals</div>
                                </div>
                                <div class="trustee-report-intro">
                                    Download the transaction, installment and service charge schedule for approved and open PF Advances.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-schedule-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-loan-schedule-report>
                            </div>
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">PF Advance Balance</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows the balances of open PF Advances for all employees at end of the month selected.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-monthly-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-loan-monthly-report>
                            </div>
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">PF Advances Awaiting Disbursement</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows all PF Advances that have been approved but are currently awaiting disbursement.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-awating-disbursement-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-loan-awating-disbursement-report>
                            </div>
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">PF Advance Disbursement Report</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows list of all approved PF Advances that have been disbursed at end of month selected.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-disbursement-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-loan-disbursement-report>
                            </div>
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">PF Advance Deduction Exception Report</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows all PF Advances that are open but have at least one due installment or due service charge at end of month selected.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-deduction-exception-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-loan-deduction-exception-report>
                            </div>
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">PF Advance Manual Payment Report</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows all manual payments made by Employees against all open PF Advances during month selected.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-loan-early-settlement-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-loan-early-settlement-report>
                            </div>
                        </b-tab>
                        
                        
                        
                    </b-tabs>
                </b-tab>
                <b-tab title="PF Settlement Reports">
                
                    <b-tabs  tab-class="nav-item-trustee" content-class="mt-4" nav-wrapper-class="trustee-nav-wrapper mt-4">
                        <template v-slot:tabs-start>
                            <b-nav-item disabled href="#" class="trustee-nav-first-wrapper">
                                <div class="trustee-nav-first">
                                    <div class="trustee-nav-head">Provident Fund Settlement Reports</div>
                                    <div class="trustee-nav-subhead">Get a clear picture of your pending and disbursed Provident Fund balance Settlements for leaving Employees. </div>
                                </div>
                            </b-nav-item>
                        </template> 
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Awaiting for Disbursement Report</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows all pending PF Settlements awaiting disbursement for Employees who have either left the organization or left the PF scheme.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-settlement-awating-disbursment-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-settlement-awating-disbursment-report>
                            </div>
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Disbursed Settlement Reports</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows approved and disbursed PF Settlements for the month selected for Employees who have either left the organization or left the PF scheme.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-settlement-disbursment-report :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-settlement-disbursment-report>
                            </div>
                        </b-tab>
                        <b-tab lazy title-item-class="trustee-nav wi-three">
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">PF Settlement Report</div>
                                </div>
                                <div class="trustee-report-intro">
                                    This report shows all PF Settlements made for the selected fiscal year for Employees who have either left the organization or left the PF scheme.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-settlement-report :pf_settings="this.pf_settings" :pageurl="this.$api_url" :is_trustee="this.trustee"></pf-settlement-report>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-tab>
            </b-tabs>                             
        </div>  
       </div>
</template>

<script>
    
    
    export default{
        
        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl' , 'flag'],   
        components: {
            
        },     
        data(){
            
            return {
                
                pageUrl:this.$api_url,
                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},
                pf_settings :{pf_year_end:{ opt_value: 0, status: 0 },pf_profit_distribute_type:{ opt_value: 'equal', status: 0 },},
                empty_result : 'Fetching data..',
                fiscal_year : '',
                payroll_reporting_data : [],
                trustee:1,
                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            
            openMe: function()
            {
                this.$bvModal.show('view-details');
            },
            getPFSettings: function()
            { 
                
                let currentObj = this;
                axios.get(this.$api_url+'/pf/settings').then(function (response) {
                    currentObj.pf_settings = response.data.data;
                   
                        
                })  
                .catch(function (error) {
                console.log(error);
                });
                
            },

        },
        created: function(){
            this.fiscal_year = this.getCurrentFinancialYear();
            this.getPFSettings();
        },
        computed: 
        {
            
        }
    }
</script>
